import styles from "./cart-empty.module.css";

export const CartEmpty = ({
  className,
  onClose



}: {className?: string;onClose?: () => void;}) => {
  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <aside className={`${styles.cartEmptyStyles} ${className || ""}`}>
      <div className={styles.cartEmptyOverlay} onClick={handleClose}></div>
      <div className={styles.cartEmptyContainer}>
        <button className={styles.cartEmptyClose} onClick={handleClose}>
          <span className='icon-close'></span>
        </button>
        <div className={styles.cartEmptyContent}>
          <div className={styles.cartEmptyIcon}>
            <span className='icon-cart-outline'></span>
          </div>
          <div className={styles.cartEmptyText}>
            Aún no tienes items en tu carrito 😞, animate a comprar ahora.
          </div>
        </div>
      </div>
    </aside>);

};